<template>
  <div class="backGroundB">
    <div class="w1200 product">
      <div class="nav">
        <span style="color: #808080">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/productHome' }">产品选型</el-breadcrumb-item>
          <el-breadcrumb-item v-if="typeCode == 'spec'" :to="{ path: '/newSpecList' }">经销商订货规格列表</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ path: '/specList' }">规格列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{ specification.productName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="product_top">
        <div class="product_top_mesg">
          <div class="flex_my">
            <div>
              <h2>{{ specification.name }}</h2>
              <span class="product_top_mesg_icon color999">{{ specification.productName }}</span>
            </div>
            <img :src="specification.brandLogo" style="height: 44px;width: 93px;flex:0 0 93px;margin-left:10px"
                 v-if="specification.brandLogo">
          </div>
          <p class="product_top_mesg_p color999" style="margin-bottom:10px">
            <span class="circle_my"></span>
            <span> 用途： </span>
            {{ specification.purpose }}
          </p>
        <p class="product_top_mesg_p color999" style="display:flex;align-items:center">
            <span class="circle_my"></span>
            <span> 公司： </span>
            {{ specification.company }}
           <svg @click="startChat(userUuid)" t="1701065082148" class="icon wxIcon" viewBox="0 0 1024 1024"  version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2351" width="18" height="18"><path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" fill="#009999" p-id="2352"></path></svg>
          </p>
          <div class="product_top_mesg_state">
            <div
                class="mesg_state_box"
                v-for="(item, index) in stateList"
                :key="index">
              <p>{{ item.name }}</p>
              <p>{{ item.nums }}</p>
            </div>
          </div>
          <div class="mesg_price_box">
            <p class="product_top_mesg_price">
              <span class="name"> 价格： </span>
              <span class="money" v-if="specification.faceToFace">面议</span>
              <span class="money" v-else><span>￥</span>{{ specification.price }}</span>元/{{ specification.unit }}
            </p>
            <div class="mesg_price_box_btn" v-if="typeCode == 'spec'">
              <el-button type="text" @click="getOrderPage('at')" class="btn_xj">
                经销商下单
              </el-button>
              <el-button type="primary" @click="getOrderPage('join')" class="btn_db">
                加入订货单
              </el-button>
            </div>
            <div class="mesg_price_box_btn" v-else>
              <el-button type="text" @click="getInquiry" class="btn_xj">
                <img src="../../assets/image/icon1.png" style="width:18px;height:18px"/>
                立即询价
              </el-button>
              <el-button type="primary" @click="joinCompare(specification)" class="btn_db">
                <i class="el-icon-circle-plus-outline" style="font-size:16px"/>
                加入对比
              </el-button>
            </div>
          </div>
        </div>
        <!-- <swiperBox :swiperList="swiperList" style="border-radius:8px"></swiperBox> -->
        <el-carousel height="350px" style="width:500px;flex:0 0 500px" indicator-position="outside">>
          <el-carousel-item v-for="(item,index) in swiperList" :key="index">
            <img :src="item.imgs" style="width:100%;height:100%;border-radius:10px"/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="table_mesg">
        <p class="title">产品材料</p>
        <el-table :data="tableData" style="width: 100%" :header-cell-style="{
            color: '#333333',
            background: '#fff',
          }">
          <el-table-column prop="name" label="资料名称" align="center">
          </el-table-column>
          <el-table-column prop="dictionaryName" label="类型" align="center">
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.createTime">{{ scope.row.createTime.split(' ')[0] }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="version" label="版本" align="center">
          </el-table-column>
          <el-table-column prop="size" label="大小" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.size + 'B' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="czbox">
                <el-button type="text" @click="handlePreview(scope.row)">预览</el-button>
                <el-button type="text" @click="downloadTemplate(scope.row.url,scope.row.name)">下载</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="product_bottom">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="产品参数" name="1">
            <productMessage :specification="specification"></productMessage>
          </el-tab-pane>
          <el-tab-pane label="产品图片" name="2">
            <productImg :specification="specification"></productImg>
          </el-tab-pane>
           <el-tab-pane label="产品视频" name="3">
            <productComDetails :productInfo="specification" :intro="false"></productComDetails>
          </el-tab-pane>
        </el-tabs>
      </div>
    <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
      <inquiry ref="inquireRef"></inquiry>
    </div>
  </div>
</template>

<script>
// 轮播图
import swiperBox from "./components/swiperBox"
// 询价
import inquiry from "./components/inquiry"
// 产品详情
import productMessage from "./components/productMessage";
// 产品列表
import productImg from "./components/productImg";
// 产品资料
import productComDetails from "./components/productComDetails";

 import chatDialog from '../chat/chatDialog.vue'
// 需要添加对比的页面就加这个
import {mixins} from "./mixin/index.js"
import axios from 'axios'; // 引入axios
import {addProductCart, geSpecification} from "../../utils/product";

import {getNewcurrent,getRongCloudUser} from '../../utils/interface'
import {mapState} from "vuex";
export default {
  mixins: [mixins],
  components: {
    productImg,
    productComDetails,
    productMessage,
    inquiry,
    swiperBox,
    chatDialog
  },
  data() {
    return {
      specification: {},
      activeName: "1",
      typeCode: "",
      tableData: [],
      swiperList: [],
      comPareList: [],
      stateList: [],
      userUuid:'',
       userMessages:''
    };
  },
  computed: {
     ...mapState({
       isLogin: "isLogin",
     })
  },
  created() {
    this.uuid = this.$route.query.uuid;
    this.typeCode = this.$route.query.typeCode;
    this.getSpecificationDetail(this.uuid)
    getNewcurrent().then((res) => {
        this.userMessages = res;
    })
  },
  methods: {
    getOrderPage(type) {
      let row = this.specification;
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！");
        this.$router.push({
          name: "login",
        });
        return false;
      } else if (this.$store.state.isUsermessage.identity === 'PERSONAL' || this.$store.state.isUsermessage.identity === 'ANONYMOUS') {
        this.$confirm('请先进行企业资质认证!', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.sessionStorage.setItem("userServeId", "11");
          let routeData = this.$router.resolve({
            name: "userCenter",
            params: {
              userServeId: '11',
            },
          });
          window.open(routeData.href, "_target");
        });
        return false;
      } else if (row.enterpriseId === this.$store.state.isUsermessage.enterpriseUuid) {
        this.$message.error("不能购买自己企业的产品");
        return false;
      } else {
        if (type == 'at') {
          // 数据完成之后跳转页面
          window.sessionStorage.removeItem("updateForm");
          let updateForm = [{
            imgUrl: row.coverImages[0].url,
            productUuid: row.productUuid,
            productName: row.productName,
            productSpecUuid: row.uuid,
            specName: row.name,
            unit: row.unit
          }];
          window.sessionStorage.setItem("updateForm", JSON.stringify(updateForm));
          this.getPage("productOrderPage")
        } else {
          this.addOrderCar(row);
        }
      }
    },
    addOrderCar(item) {
      addProductCart({specUuid: item.uuid, num: 1}).then((res) => {
        if (res.success) {
          this.$message.success("添加成功");
          this.$emit("countNum");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 跳
    getPage(routerName, uuid, typeCode) {
      let routeData = this.$router.resolve({
        name: routerName,
        query: {
          uuid: uuid,
          typeCode: typeCode,
        },
      });
      window.open(routeData.href);
    },
    getSpecificationDetail(uuid) {
      geSpecification(uuid).then((res) => {
        if (res.success) {
          res.data.videoList = res.data.videos;
          this.specification = res.data;
          console.log(111,this.specification)
          this.userUuid = res.data.createUserUuid
          this.specification.params.forEach((item) => {
            this.stateList.push({
              name: item.split(":")[0],
              nums: item.split(":")[1]
            })
          })
          this.tableData = this.specification.informationList;
          this.specification.coverImages.forEach((item) => {
            this.swiperList.push({
              imgs: item.url
            })
          })
        }
      });
    },
    getInquiry() {
      if (!this.$store.state.isLogin) {
        this.$message.warning('您需要先登陆哦！');
        this.$router.push({
          name: "login"
        });
        return false;
      } else {
        this.$refs.inquireRef.init(this.uuid);
      }
    },
    downloadTemplate(url, name) {
      // 用fetch发送请求
      fetch(url).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    },
    handlePreview(row) {
      let fileExtension = row.url.split('.').pop();
      if (fileExtension == 'pdf') {
        axios.get(row.url, {responseType: 'blob'}).then((data) => {
          let responseData = data.data;
          let blob = new Blob([responseData], {type: 'application/pdf;charset=utf-8'});
          const href = URL.createObjectURL(blob);
          window.open(href, 'newWindow');
        })
      } else {
        this.$message({
          message: '只能预览pdf文件',
          type: 'warning'
        });
      }
    },
    handleClick() {},
    startChat(targetUserId) {
      if (this.isLogin) {
          let user = this.$store.state.isUsermessage;
          if(this.userUuid==this.userMessages.uuid){
              this.$message.error('检测当前联系企业与您处于同一企业，暂不支持联系!');
              return false;
          }else {
              getRongCloudUser(targetUserId).then(res => {
                  this.$refs.chatDialogRef.init(user.uuid, user.name, user.headUrl,targetUserId, res.name, res.headUrl);
              });
          }
      } else {
          this.$message({
              type: "success",
              message: "您需要先登录哦！",
          });
          this.$router.push('/login')
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "./style/index";

/deep/ .el-tabs__item {
  font-weight: 600;
}

/deep/ .el-table--fit {
  border: 1px solid #e3e3e3;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #F3F3F3;
}

.wxIcon{
  color: #099;
  cursor: pointer;
  margin-left: 10px;
  font-size: 16px;
}
.flex_my {
  display: flex;
  justify-content: space-between;
}

.color999 {
  color: #999999;
}

.circle_my {
  width: 6px;
  height: 6px;
  display: inline-block;
  background-color: #D9D9D9;
  border-radius: 50%;
  margin-right: 10px;
}

.product {
  color: #333333;

  .product_top {
    display: flex;
    background-color: #fff;
    padding: 20px;
    justify-content: space-between;
    margin-bottom: 20px;
    border-top: 1px solid #F5F8FC;
    border-bottom: 1px solid #F5F8FC;

    .product_top_mesg {
      position: relative;
      margin-right: 40px;
      width: 100%;

      h2 {
        margin-bottom: 5px;
        font-size: 20px;
      }

      .product_top_mesg_icon {
        margin-bottom: 20px;
        font-size: 14px;
        display: inline-block;
      }

      .product_top_mesg_p {
        margin-bottom: 25px;
        font-size: 14px;
      }

      .mesg_price_box {
        margin-top: 40px;
        position: relative;

        .product_top_mesg_price {
          .name {
            color: #999999;
            font-size: 14px;
          }

          .money {
            font-size: 28px;
            color: red;
            margin-right: 10px;
            font-weight: bold;

            span {
              font-size: 14px;
            }
          }
        }

        .mesg_price_box_btn {
          margin-top: 20px;

          .btn_xj {
            background-color: rgba(22, 153, 153, 0.20);
            width: 104px;
            height: 36px;
            text-align: center;
            padding: 0;
            line-height: 36px;
            color: #169999;
            font-size: 14px;
            border-radius: 4px;
          }

          .btn_db {
            background-color: #169999;
            width: 104px;
            height: 36px;
            text-align: center;
            padding: 0;
            line-height: 36px;
            color: #fff;
            font-size: 14px;
            border-radius: 4px;
            margin-left: 30px;
          }
        }
      }

      .product_top_mesg_state {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 50px;

        .mesg_state_box {
          color: #333;
          font-size: 14px;
          min-width: 100px;
          text-align: center;
          padding: 15px;
          background: #F9F9F9;
          border-radius: 8px;
          margin-right: 15px;
          margin-top: 15px;
        }
      }
    }

    img {
      flex-shrink: 0;
      width: 500px;
      height: 400px;
    }
  }

  .table_mesg {
    display: flex;

    .title {
      background: #F9F9F9;
      margin-right: 8px;
      padding: 0 20px;
      text-align: center;
      flex-shrink: 0;
      writing-mode: vertical-lr;
      border: 1px solid #E3E3E3;
      font-weight: 600;
      letter-spacing: 2px;
    }
  }

  .product_bottom {
    margin-top: 20px;
    background: #fff;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/productDetails.vue